// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdfDisplayDiv {
    background-color: white;
    width: 70%;
    min-height: 84vh;
    margin: auto;
    margin-top: 2%;
    margin-bottom: 4% !important;
    padding-left: 2%;
    /* padding-right: -4% !important; */
    padding-top: 0% !important;
    padding-bottom: 0% !important;
    overflow: auto;
    max-height: 84vh;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 5px;
    height: 84vh;
}
.temp3MainDiv{
    /* background-color: aqua; */
    min-height: 84vh;
    width: 100%;
}
.temp3LeftCol{
    background-color: #144d41;
    background-color: #333132;
    background-color: #28555e;
    background-color: #102429;
    padding-top:5%;
    min-height: 84vh;
    padding-left: 0%;
    color: white;
    font-size: 6px;

}
.temp3RightCol{
    /* background-color: #082d4d; */
    min-height: 84vh;
    padding-top: 0%;
    color: white;
    padding-right: 4%;
    margin-top: -4.5%;
}
.template3HeadingProfile{
    margin-bottom: 1.5% !important;
}
.profileName {
    padding: 0;
    margin: 0;
    padding-left: 4%;
    position: relative;
    font-weight: 520;
    color: rgb(30, 37, 50);
    color: rgb(22, 89, 143);
    font-size: 10px;
}
.temp3NameDiv {
    margin: 0;
    padding: 0;
    display: inline-block;
    width: 100% !important; 
    margin: auto;
    /* background-color: #5ec57e; */
    margin-left: 6% !important;
    display: block;
    margin-top: 6% !important;
    margin-left: -8%;
    text-align: center;
}
.temp3ResumeName{
    font-size: 10px;
    font-weight: 620;
}
.temp3Hr{
    width: 17%;
    margin: auto;
    margin-top: 6%;
    margin-bottom: 6%;
}
.temp3ResumeTitle{
    font-weight: 500;
    font-size: 7px  !important;
    margin-bottom: 5%;
    color: #62a844;
}
.temp2GreyFont{
    margin-top: 12% !important;
    /* color: rgb(144, 154, 178) !important; */
    color: #62a844 !important;

}
.temp2PersonalDetails{
    font-size: 10px !important;
}
.temp3ProfileDetails{
    padding-left: 22%;
    margin-top: 12% !important;
}
.temp3ImageDiv{
    /* background-color: antiquewhite; */
    width: 100%;
    margin-top: 8%;
}
.temp3DisplayImage{
    width: 40px !important;
    position: relative;
    left: 40%;
    border-radius: 100%;
}
.temp3PersonalDetails{
    font-size: 10px;
}
.temp3Underline{
    /* text-decoration: underline; */
    color: #62a844;
}
.temp3Headings{
    color: rgb(30, 37, 50);
    /* color: #62a844; */

}
.temp3ProfileName{
    color: rgb(30, 37, 50) !important;
    /* color: #62a844 !important;  */


}


/* Media query for mobile view */
@media screen and (max-width: 890px) {
    .temp3RightCol {
        width: 66%; /* Full width for both columns */
        /* padding-top: 5%;  */
        /* padding-left: 5%; */
    }

    .temp3LeftCol {
        width: 33%; /* Full width for both columns */
        /* padding-top: 5%;  */
        /* right: -6.8%; */
    }
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/temp3.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,mCAAmC;IACnC,0BAA0B;IAC1B,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;;AAElB;AACA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,0CAA0C;IAC1C,yBAAyB;;AAE7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,gCAAgC;IAChC,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,oBAAoB;;AAExB;AACA;IACI,iCAAiC;IACjC,gCAAgC;;;AAGpC;;;AAGA,gCAAgC;AAChC;IACI;QACI,UAAU,EAAE,gCAAgC;QAC5C,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,UAAU,EAAE,gCAAgC;QAC5C,sBAAsB;QACtB,kBAAkB;IACtB;AACJ","sourcesContent":[".pdfDisplayDiv {\n    background-color: white;\n    width: 70%;\n    min-height: 84vh;\n    margin: auto;\n    margin-top: 2%;\n    margin-bottom: 4% !important;\n    padding-left: 2%;\n    /* padding-right: -4% !important; */\n    padding-top: 0% !important;\n    padding-bottom: 0% !important;\n    overflow: auto;\n    max-height: 84vh;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 5px;\n    height: 84vh;\n}\n.temp3MainDiv{\n    /* background-color: aqua; */\n    min-height: 84vh;\n    width: 100%;\n}\n.temp3LeftCol{\n    background-color: #144d41;\n    background-color: #333132;\n    background-color: #28555e;\n    background-color: #102429;\n    padding-top:5%;\n    min-height: 84vh;\n    padding-left: 0%;\n    color: white;\n    font-size: 6px;\n\n}\n.temp3RightCol{\n    /* background-color: #082d4d; */\n    min-height: 84vh;\n    padding-top: 0%;\n    color: white;\n    padding-right: 4%;\n    margin-top: -4.5%;\n}\n.template3HeadingProfile{\n    margin-bottom: 1.5% !important;\n}\n.profileName {\n    padding: 0;\n    margin: 0;\n    padding-left: 4%;\n    position: relative;\n    font-weight: 520;\n    color: rgb(30, 37, 50);\n    color: rgb(22, 89, 143);\n    font-size: 10px;\n}\n.temp3NameDiv {\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    width: 100% !important; \n    margin: auto;\n    /* background-color: #5ec57e; */\n    margin-left: 6% !important;\n    display: block;\n    margin-top: 6% !important;\n    margin-left: -8%;\n    text-align: center;\n}\n.temp3ResumeName{\n    font-size: 10px;\n    font-weight: 620;\n}\n.temp3Hr{\n    width: 17%;\n    margin: auto;\n    margin-top: 6%;\n    margin-bottom: 6%;\n}\n.temp3ResumeTitle{\n    font-weight: 500;\n    font-size: 7px  !important;\n    margin-bottom: 5%;\n    color: #62a844;\n}\n.temp2GreyFont{\n    margin-top: 12% !important;\n    /* color: rgb(144, 154, 178) !important; */\n    color: #62a844 !important;\n\n}\n.temp2PersonalDetails{\n    font-size: 10px !important;\n}\n.temp3ProfileDetails{\n    padding-left: 22%;\n    margin-top: 12% !important;\n}\n.temp3ImageDiv{\n    /* background-color: antiquewhite; */\n    width: 100%;\n    margin-top: 8%;\n}\n.temp3DisplayImage{\n    width: 40px !important;\n    position: relative;\n    left: 40%;\n    border-radius: 100%;\n}\n.temp3PersonalDetails{\n    font-size: 10px;\n}\n.temp3Underline{\n    /* text-decoration: underline; */\n    color: #62a844;\n}\n.temp3Headings{\n    color: rgb(30, 37, 50);\n    /* color: #62a844; */\n\n}\n.temp3ProfileName{\n    color: rgb(30, 37, 50) !important;\n    /* color: #62a844 !important;  */\n\n\n}\n\n\n/* Media query for mobile view */\n@media screen and (max-width: 890px) {\n    .temp3RightCol {\n        width: 66%; /* Full width for both columns */\n        /* padding-top: 5%;  */\n        /* padding-left: 5%; */\n    }\n\n    .temp3LeftCol {\n        width: 33%; /* Full width for both columns */\n        /* padding-top: 5%;  */\n        /* right: -6.8%; */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
